
// @ts-check

import React, { useState, useEffect } from "react";
import DonorCardWebLayout from "./DonorCardWebLayout";
import { resultAtomsToParsedDonors } from "./paginator";
import { getResultsFor } from "./GetQueryResultsFunctions";
import { pushDonorListIsPopulated } from "./AnalyticsFunctions";


import ResultsLoadingManagerWebInstance from "./ResultsLoadingManagerWebInstance";

import "../styles/WebLoadingText.css";


/**
 * @typedef {import("./coreTypes").QuerySpec} QuerySpec
 * @typedef {import("./coreTypes").ResultAtom} ResultAtom
 * @typedef {import("./coreTypes").JSResultAtom} JSResultAtom
 */

/**
 * @param {{ donorName: string }} props 
 * @returns {JSX.Element | null}
 */
 function WebResultsDonorsContent(props) {
    
    /**
     * @type {[JSResultAtom[], React.Dispatch<React.SetStateAction<JSResultAtom[]>>]}
     */
    // @ts-ignore
    const [donors, setDonors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);


    const comb = ResultsLoadingManagerWebInstance.generateCombinedMethodsFromSetter(setDonors);
    const generateLoadingIdAndSetAsActive = comb.generateLoadingIdAndSetAsActive;
    const setDonorsIfCurrentLoadingId = comb.setResultsIfCurrentLoadingId;    


    useEffect(() => {

        /** @type {QuerySpec} */
        const querySpec = [['donor_search_string', props.donorName]];

        setDonors([]);

        const id = generateLoadingIdAndSetAsActive();
        setIsLoading(true);

        const errorHandler = _ => { setIsLoading(false); setIsError(true); };

        const resultsObj = getResultsFor(querySpec, null);

        /**
         * @type {function(ResultAtom[]):void}
         */
        let nextHandler;
        
        nextHandler = (res) => {
            if (ResultsLoadingManagerWebInstance.getCurrentLoadingId() === id
                && res.length > 0) {
                setDonors(d => d.concat(resultAtomsToParsedDonors(res)));
                resultsObj.getNext().then(nextHandler).catch(errorHandler);
            }
            else {
                setIsLoading(false);
            }
        };

        resultsObj.initial.then(res => {
            setDonorsIfCurrentLoadingId(id, resultAtomsToParsedDonors(res));
            setIsError(false);

            if (res.length > 0) {
                pushDonorListIsPopulated(true);
                resultsObj.getNext().then(nextHandler).catch(errorHandler);
            } else {
                pushDonorListIsPopulated(false);
                setIsLoading(false);
            }
        }).catch(errorHandler);

    // eslint-disable-next-line
    }, [props.donorName]);

    const errorStyle = { color: 'white', fontSize: 16, fontFamily: 'Arial', };

    return (
        <div>
            <p style={{ paddingBottom: 40 }}></p>
            { !isError && !isLoading && donors.length === 0 && <p style={errorStyle}>There are no results.</p>}
            { !isError && <DonorCardWebLayout donors={donors} singleColumn={false} />}
            { !isLoading && isError && <p style={errorStyle}>There was an error fetching the list of donors.</p> }
            { (isLoading)
                ? <div className="web-loading-text__container">
                    <p className="web-loading-text__loading">Loading</p>
                    <p className="web-loading-text__dot-1"> . </p>
                    <p className="web-loading-text__dot-2"> . </p>
                    <p className="web-loading-text__dot-3"> . </p>
                  </div> 
                : null }
        </div>
        );
}

export default WebResultsDonorsContent;